<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XRCdQw/images/cover.jpg?1699150478214" alt="This image is the cover for the book Ancient Battle Formations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ancient Battle Formations
      </h1>
      <p class="bookDescription body article font2">
        <b>An analysis of ancient Greek, Roman, and Macedonian winning battle formations, from why they worked, the equipment and men used, and how they broke down.</b><br/><br/> Justin Swanton examines the principal battle-winning formations of the ancient world, determining their composition, function and efficacy. An introductory chapter looks at the fundamental components of the principal battle formations of heavy and light infantry, cavalry, elephants and chariots, showing how they bolstered the individual's soldier's willingness to fight.<br/><br/> The rest of the book focuses on massed infantry that reigned supreme in this era: the heavily armored Greek hoplite phalanx that was immune to the weaponry of its non-Greek opponents; the Macedonian pike phalanx that was unbeatable against frontal attacks so long as it kept order; the Roman triplex acies which, contrary to popular opinion, consisted of continuous lines in open order, with file spaces wide enough to allow embattled infantry to fall back after which those files closed up instantly against the enemy.<br/><br/> A careful study of the Greek and Latin of the sources sheds fresh light on how these formations were organized and worked, reevaluating many conventional notions and leading to some surprising conclusions.<br/><br/><b>Praise for <i>Ancient Battle Formations</i></b><br/><br/><b>“This book is both important for its thoroughly researched, original and well-argued historical conclusions and an enjoyable read. Highly recommended.” —Professor F. Noel Zaal (BA, LLB University of Natal, LLM Durban-Westville, LLM Columbia, PhD Wits</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Justin Swanton
      </h2>
      
      <p class="authorDescription body article">A long-standing member of the Society of Ancients, Justin Swanton has been studying ancient warfare many years, making a close reading of ancient battle accounts in the original Greek and Latin. He is editor of _Slingshot_, the journal of the Society of Ancients, and is a graphic designer by profession, hence the striking diagrams that accompany his writing. He is a keen wargamer in his spare time and has published one novel set in late Antiquity. Justin lives in Durban, South Africa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1486f807